module.exports = __webpack_public_path__ + "assets/fonts/opensans-extrabolditalic-webfont.woff";